<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <hr />
              <br />
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> Título:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="cancellation_reasons.title"
                          placeholder=""
                        />
                      </div>
                      <div class="col-md-6">
                        <label for="company_id">Empresa:</label>
                        <v-select
                          v-model="cancellation_reasons.company_id"
                          class="vselect"
                          :options="companies"
                          :reduce="(companies) => companies.id"
                          :label="'fantasy_name'"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> Status:
                        </label>
                        <select
                          v-model="cancellation_reasons.status"
                          class="form-control"
                        >
                          <option :value="1">Ativo</option>
                          <option :value="0">Inativo</option>
                        </select>
                      </div>
                    </div>
                    <br />
                    <span class="required_fields mt-2">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <router-link
                        to="/cancellation_reasons"
                        class="btn btn-back"
                      >
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add ml-1" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      cancellation_reasons: {
        title: "",
        status: "",
        company_id: "",
      },
      companies: [],
      errors: undefined,
      previewImage: null,
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "cancellation_reasons";

      let fd = self.cancellation_reasons;

      if (self.cancellation_reasons.id) {
        fd._method = "PUT";
        api += "/" + self.cancellation_reasons.id;
      }

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/cancellation_reasons");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCancelamento: function (id) {
      const self = this;
      const api = self.$store.state.api + "cancellation_reasons/" + id;

      axios
        .get(api)
        .then((response) => {
          self.cancellation_reasons = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    self.getCompanies();
    let id = self.$route.params.id;
    if (id) {
      self.getCancelamento(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
</style>